// extracted by mini-css-extract-plugin
export default {"modal":"FullScreenModal_modal__l1xhR","closeWrapper":"FullScreenModal_closeWrapper__wTsD6"};